import { render, staticRenderFns } from "./modalnps.vue?vue&type=template&id=b8a4e7e4&"
import script from "./modalnps.vue?vue&type=script&lang=js&"
export * from "./modalnps.vue?vue&type=script&lang=js&"
import style0 from "./modalnps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports